'use client'

import Image from 'next/image'
import { ABHA_HERO_SUCCESS_BADGE_ICON } from '@components/NewProduct/constants'

export type AbhaHeroSuccessBadgeProps = {
  label: string
  variant?: 'default' | 'onDark' | 'onLight' | 'onShowSurface'
}

export const AbhaHeroSuccessBadge = ({ label, variant = 'default' }: AbhaHeroSuccessBadgeProps) => (
  <div className={`abha-hero-success__badge abha-hero-success__badge--${variant}`}>
    <span className="abha-hero-success__badge-icon" aria-hidden>
      <Image
        src={ABHA_HERO_SUCCESS_BADGE_ICON}
        alt=""
        width={32}
        height={32}
        className="abha-hero-success__badge-icon-image"
      />
    </span>
    <span className="abha-hero-success__badge-text">{label}</span>
  </div>
)
